import React from 'react';
import { AddressDto, ContactDto } from '../../../types';
import edit from '../../../assets/icons/new_icon/edit-white.svg';
import { useLocation } from 'react-router-dom';
interface Props {
  label: string;
  setCurrentShipmentStatus: any;
  setEditRouteForm: any;
  addressFormData: AddressDto;
  contactFormData: ContactDto;
  isAddLeg?: any;
  handleEdit?: any;
  setShowSummary?: any;
  setShowRates?: any;
}
function SummaryAddressContactFields({
  label,
  setCurrentShipmentStatus,
  setEditRouteForm,
  addressFormData,
  contactFormData,
  isAddLeg,
  handleEdit,
}: Props) {
  const location = useLocation();
  const isAddLegFromRoute = location?.pathname === '/app/add-leg';

  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header d-flex justify-content-between'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>{label}</h5>
        {!isAddLeg && (
          <div
            className='my-auto'
            style={{ paddingRight: '20px' }}
          >
            <button
              type='button'
              className='editwhiteBg'
              data-testid='editButton'
              onClick={() => {
                if (isAddLegFromRoute) {
                  handleEdit();
                } else {
                  setCurrentShipmentStatus('select-route');
                  setEditRouteForm(true);
                }
              }}
            >
              <img
                src={edit}
                alt={edit}
              />
            </button>
          </div>
        )}
      </div>
      <div className='card-body p-4 pt-2 h-auto'>
        <div className='row'>
          <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
            <label className='global-text-16'>Country</label>
          </div>
          <div
            className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
            id='summary_origin_country'
          >
            {addressFormData?.country ? addressFormData?.country : 'N/A'}
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
            <label className='global-text-16'>Address</label>
          </div>
          <div
            className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
            id='summary_origin_address'
          >
            {addressFormData?.address || addressFormData?.city
              ? `${addressFormData?.address}, ${addressFormData?.city}, ${addressFormData?.province}, ${addressFormData?.postal_code}`
              : 'N/A'}{' '}
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
            <label className='global-text-16'>Company</label>
          </div>
          <div
            className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
            id='summary_origin_company'
          >
            {contactFormData?.company_name
              ? contactFormData?.company_name
              : 'N/A'}
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
            <label className='global-text-16'>Name</label>
          </div>
          <div
            className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
            id='summary_origin_name'
            style={{ lineBreak: 'anywhere' }}
          >
            {contactFormData?.name ? contactFormData?.name : 'N/A'}
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
            <label className='global-text-16'>Email</label>
          </div>
          <div
            className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext '
            style={{ lineBreak: 'anywhere' }}
            id='summary_origin_email'
          >
            {contactFormData?.email ? contactFormData?.email : 'N/A'}
          </div>
        </div>

        <div className='row mt-2'>
          <div className='col-6 col-md-6 col-lg-5 col-xl-4'>
            <label className='global-text-16'>Phone Number</label>
          </div>
          <div
            className='col-6 col-md-6 col-lg-7 col-xl-8 boldglobaltext'
            id='summary_origin_phone'
          >
            {contactFormData?.phone ? contactFormData?.phone : 'N/A'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SummaryAddressContactFields;
